import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AutomationFlowsAPI from '../../api/automationFlows';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getAutomationFlows(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isFetching: true });
    try {
      const response = await AutomationFlowsAPI.get();
      commit(types.SET_AUTOMATION_FLOWS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, flowObj) => {
    commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isCreating: true });
    try {
      const response = await AutomationFlowsAPI.create(flowObj);
      commit(types.ADD_AUTOMATION_FLOW, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isUpdating: true });
    try {
      const response = await AutomationFlowsAPI.update(id, updateObj);
      commit(types.EDIT_AUTOMATION_FLOW, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isDeleting: true });
    try {
      await AutomationFlowsAPI.delete(id);
      commit(types.DELETE_AUTOMATION_FLOW, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUTOMATION_FLOW_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_AUTOMATION_FLOW_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.ADD_AUTOMATION_FLOW]: MutationHelpers.create,
  [types.SET_AUTOMATION_FLOWS]: MutationHelpers.set,
  [types.EDIT_AUTOMATION_FLOW]: MutationHelpers.update,
  [types.DELETE_AUTOMATION_FLOW]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
